export type OpenedFile = {
  name: string;
  kind: "pdf" | "docx";
  buffer: ArrayBuffer;
  mimeType?: string;
  /** Device content:// or file:// for reopen from chat list */
  fileUri?: string;
  /** Linked Nevisign cloud document id when opened from studio list */
  nevisignDocumentId?: string;
};

export function detectKind(
  name: string,
  mimeType?: string | null,
  buffer?: ArrayBuffer | Uint8Array | null
): "pdf" | "docx" | "doc" | "unknown" {
  const lower = (name || "").toLowerCase();
  const mime = (mimeType || "").toLowerCase();

  if (lower.endsWith(".pdf") || mime === "application/pdf") return "pdf";
  if (
    lower.endsWith(".docx") ||
    mime ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return "docx";
  }
  if (lower.endsWith(".doc") || mime === "application/msword") return "doc";

  // Magic-byte sniff for picker / Open-with payloads without a reliable name
  if (buffer && buffer.byteLength >= 5) {
    const bytes =
      buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    // %PDF-
    if (
      bytes[0] === 0x25 &&
      bytes[1] === 0x50 &&
      bytes[2] === 0x44 &&
      bytes[3] === 0x46
    ) {
      return "pdf";
    }
    // ZIP / OOXML (PK)
    if (bytes[0] === 0x50 && bytes[1] === 0x4b) {
      return "docx";
    }
  }

  return "unknown";
}

/** Ensure ArrayBuffer is not detached and is a fresh copy for pdf.js / JSZip. */
export function cloneArrayBuffer(source: ArrayBuffer): ArrayBuffer {
  const copy = new ArrayBuffer(source.byteLength);
  new Uint8Array(copy).set(new Uint8Array(source));
  return copy;
}
